export interface EditorKeyboardHandlers {
  onUndo?: () => void;
  onRedo?: () => void;
  onDelete?: () => void;
  onSelectPrevious?: () => void;
  onSelectNext?: () => void;
  onSave?: () => void;
}

const KEY_UNDO = 'z';
const KEY_REDO = 'y';
const KEY_DELETE = 'Delete';
const KEY_BACKSPACE = 'Backspace';
const KEY_ARROW_UP = 'ArrowUp';
const KEY_ARROW_DOWN = 'ArrowDown';

export function installEditorShortcuts(handlers: EditorKeyboardHandlers): () => void {
  const handleKeyDown = (event: KeyboardEvent): void => {
    const target = event.target as HTMLElement | null;
    const tag = target?.tagName?.toLowerCase() ?? '';
    const isTyping =
      target?.isContentEditable === true ||
      tag === 'input' ||
      tag === 'textarea' ||
      tag === 'select';

    const commandKey = event.metaKey || event.ctrlKey;

    if (commandKey && event.key.toLowerCase() === KEY_UNDO) {
      if (event.shiftKey) {
        event.preventDefault();
        handlers.onRedo?.();
      } else {
        event.preventDefault();
        handlers.onUndo?.();
      }
      return;
    }

    if (commandKey && event.key.toLowerCase() === KEY_REDO && !event.shiftKey) {
      event.preventDefault();
      handlers.onRedo?.();
      return;
    }

    if (commandKey && event.key.toLowerCase() === 's') {
      event.preventDefault();
      handlers.onSave?.();
      return;
    }

    if (isTyping) {
      return;
    }

    if ((event.key === KEY_DELETE || event.key === KEY_BACKSPACE) && event.key !== KEY_BACKSPACE) {
      event.preventDefault();
      handlers.onDelete?.();
      return;
    }

    if (event.key === KEY_ARROW_UP) {
      event.preventDefault();
      handlers.onSelectPrevious?.();
      return;
    }

    if (event.key === KEY_ARROW_DOWN) {
      event.preventDefault();
      handlers.onSelectNext?.();
    }
  };

  window.addEventListener('keydown', handleKeyDown);
  return () => window.removeEventListener('keydown', handleKeyDown);
}
